import React from "react";
import { MdSearch } from "react-icons/md";
import { IoEyeOffSharp, IoEyeSharp } from "react-icons/io5";

import { cn } from "./utils/cn";

type InputProps = React.ComponentProps<"input">;

export const Input = React.forwardRef(function Input(
  props: InputProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  return (
    <input
      {...props}
      ref={ref}
      className={cn(
        "bg-[#E8E8E8] w-full h-11 px-3 rounded-lg placeholder:text-[#979797] border-b border-b-primary-1 text-sm",
        props.className
      )}
    />
  );
});

export const InputPassword = React.forwardRef(function InputPassword(
  { className, style, ...props }: InputProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className={cn("relative", className)} style={style}>
      <Input
        ref={ref}
        className="pr-10"
        type={showPassword ? "text" : "password"}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer h-6 w-6"
      >
        {showPassword ? (
          <IoEyeOffSharp className="h-6 w-6" />
        ) : (
          <IoEyeSharp className="h-6 w-6" />
        )}
      </button>
    </div>
  );
});

export const InputSearch = React.forwardRef(function InputSearch(
  { className, style, ...props }: InputProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  return (
    <div className={cn("relative", className)} style={style}>
      <Input ref={ref} className="pl-10" type="search" {...props} />
      <MdSearch size={16} className="absolute top-1/2 -translate-y-1/2 ml-4" />
    </div>
  );
});
